const Token = require('markdown-it/lib/token');

function generateSpan(text, data) {
  const spanOpen = new Token('span_open', 'span', 1);
  spanOpen.attrPush(['class', 'tooltip']);
  spanOpen.attrPush(['data-tooltip', JSON.stringify(data)]);

  const inlineText = new Token('text', '', 0);
  inlineText.content = text;

  const spanClose = new Token('span_close', 'span', -1);

  return [spanOpen, inlineText, spanClose];
}

function generateContents(content, key, data, index) {
  const before = content.slice(0, index);
  const after = content.slice(index + key.length);
  const newContents = [];
  if (before.length > 0) {
    const beforeToken = new Token('text', '', 0);
    beforeToken.content = before;
    newContents.push(beforeToken);
  }
  newContents.push(...generateSpan(key, data));
  if (after.length > 0) {
    const afterToken = new Token('text', '', 0);
    afterToken.content = after;
    newContents.push(afterToken);
  }
  return newContents;
}

function isTargetBlockOpen(type) {
  return type === 'paragraph_open' || type === 'td_open' || type === 'th_open';
}

function isTargetBlockClose(type) {
  return type === 'paragraph_close' || type === 'td_close' || type === 'th_close';
}

module.exports = function Tooltip(tooltips) {
  return function tooltipPlugin(md) {
    const copyTooltips = JSON.parse(JSON.stringify(tooltips));
    md.core.ruler.push('tooltip', function replaceTooltip(state) {
      for (let baseIndex = 0; baseIndex < state.tokens.length; baseIndex++) {
        const token = state.tokens[baseIndex];
        if (isTargetBlockOpen(token.type)) {
          let openIndex = 1;
          while (baseIndex + openIndex < state.tokens.length && !isTargetBlockClose(state.tokens[baseIndex + openIndex].type)) {
            const currentToken = state.tokens[baseIndex + openIndex];
            if (currentToken.type === 'inline') {
              for (let inlineIndex = 0; inlineIndex < currentToken.children.length; inlineIndex++) {
                // リンクの中のインライン要素は対象外とする
                if (currentToken.children[inlineIndex].type === 'link_open') {
                  while (
                    currentToken.children.length > inlineIndex &&
                    currentToken.children[inlineIndex].type !== 'link_close'
                  ) {
                    inlineIndex++;
                  }
                }
                // インライン要素の中のテキストだけを対象とする
                if (currentToken.children[inlineIndex].type === 'text') {
                  for (const [key, data] of Object.entries(copyTooltips)) {
                    const indexOfTooltip = currentToken.children[inlineIndex].content.indexOf(key);
                    if (indexOfTooltip !== -1) {
                      const newContents = generateContents(
                        currentToken.children[inlineIndex].content,
                        key,
                        data,
                        indexOfTooltip
                      );
                      currentToken.children.splice(inlineIndex, 1, ...newContents);
                      currentToken.type = 'inline';
                      currentToken.content = '';

                      // ツールチップの対象の１単語が記事中に複数出てきた場合、最初の１単語のみツールチップにするため単語を削除する
                      delete copyTooltips[key];
                    }
                  }
                }
              }
            }
            openIndex++;
          }
          baseIndex += openIndex;
        }
      }
    });
  };
};
